export default function Affiliations({ className }) {

  const rotationStyle = {
    transform: "rotate(40deg)",
    transformOrigin: "center"
  };

  return (
    <svg
      id="Affiliations"
      xmlns="http://www.w3.org/2000/svg"
      width="37.522"
      height="40.082"
      viewBox="0 0 37.522 40.082"
      className={`MuiSvgIcon-root ${className}`}
      style={rotationStyle}
    >
      <path id="Union_2" data-name="Union 2" d="M6.012,24.049a2,2,0,0,1,0-4.008h4.676V4.81H4.453V7.794A2.227,2.227,0,0,1,0,7.794V2.227A2.227,2.227,0,0,1,2.227,0h9.915a3,3,0,0,1,3,3V22.045a2,2,0,0,1-2,2Z" transform="translate(13.421 0)"/>
      <path id="Union_3" data-name="Union 3" d="M6.235,26.721a2.227,2.227,0,1,1,0-4.453h4.453V5.344H4.453V8.907A2.227,2.227,0,1,1,0,8.907V2.227A2.227,2.227,0,0,1,2.227,0h9.915a3,3,0,0,1,3,3V24.494a2.226,2.226,0,0,1-2.227,2.227Z" transform="translate(24.11 40.081) rotate(180)"/>
      <rect id="Rectangle_3377" data-name="Rectangle 3377" width="5.344" height="0.891" rx="0.445" transform="matrix(0.961, 0.276, -0.276, 0.961, 32.386, 21.088)"/>
      <rect id="Rectangle_3378" data-name="Rectangle 3378" width="2.672" height="0.891" rx="0.445" transform="matrix(-0.485, -0.875, 0.875, -0.485, 32.152, 25.807)"/>
      <rect id="Rectangle_3379" data-name="Rectangle 3379" width="2.672" height="0.891" rx="0.445" transform="matrix(-0.875, 0.485, -0.485, -0.875, 34.874, 18.599)"/>
      <rect id="Rectangle_3380" data-name="Rectangle 3380" width="5.344" height="0.891" rx="0.445" transform="translate(5.341 14.966) rotate(-178)"/>
      <rect id="Rectangle_3381" data-name="Rectangle 3381" width="2.672" height="0.891" rx="0.445" transform="translate(4.422 10.333) rotate(47)"/>
      <rect id="Rectangle_3382" data-name="Rectangle 3382" width="2.672" height="0.891" rx="0.445" transform="translate(3.529 17.985) rotate(-43)"/>
    </svg>
  );
}
